import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-aidtag-history-tracking-dw",
  templateUrl: "./aidtag-history-tracking-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AIDTagHistoryTrackingDWComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.AIDTagHistoryDW;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID2, HideFilters.ORG_ID, HideFilters.USER_ID];
}

